export {BroadcastEventManager as default};

/**
* Broadcast Event Manager
*
* Provides broadcast/subscription event message handling
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
* @deprecated 
*/
class BroadcastEventManager {
  /**
   * Stores all callback functions
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Object}
   */
  callbacks = {};

  /**
   * Sets a custom event event state
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} message
   * @param {mixed}  dara
   *
   * @return {void}
   */
  broadcast(message, data) {
    this.callBack(message, data);
  }

  /**
   * Registers an on Loaded function to be called on state change
   *
   * @public
   *
   * @param {String}   message
   * @param {Function} callable callback function
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  on(message, callable) {
    this.setCallback(message, callable);
  }

  /**
   * Destroys a registered callback
   *
   * @public
   *
   * @param {String}   message
   * @param {Function} callable callback function
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  destroy(message, callable) {
    if (!this.callbacks[message]) {
      return;
    }

    let index = this.callbacks[message].indexOf(callable);

    if (index > -1) {
      this.callbacks[message].splice(index, 1);
    }
  }

  /**
   * Sets a loadded callback function
   *
   * @private
   *
   * @since 7.0.0
   *
   * @param {String}   message
   * @param {Function} callable callback function
   *
   * @return {void}
   */
  setCallback(message, callback) {
    if (!this.callbacks[message]) {
      this.callbacks[message] = []
    }

    this.callbacks[message].push(callback);
  }

  /**
   * Calls all registered loaded calbacks
   *
   * @private
   *
   * @since 7.0.0
   *
   * @param {String} id   operation id
   * @param {mixed}  data
   *
   * @return {void}
   */
  callBack(message, data) {
    if (!this.callbacks[message]) {
      return;
    }

    this.callbacks[message].forEach((callback) => {
      callback(data);
    })
  }
}